import React from "react";
import { useHistory } from "react-router-dom";
import images from "../../../../utilities/images/images";
import QuestionWisePage from "../QuestionWisePage/QuestionWisePage";
import "./ViewSolution.css";

export default function ViewSolution() {
  const history = useHistory();

  return (
    <div>
      <div className="view_solution_header">
        <button
          className="view_solution_back_btn"
          onClick={() => history.push("/practice-summary")}
        >
          <img src={images.new_backarrow} alt="back" />
        </button>

        <h2 className="view_solution_title">View Solution</h2>
      </div>
      <QuestionWisePage
        showQuestionGrid={false}
        showBottomAnalytics={false}
      />
    </div>
  );
}